// extracted by mini-css-extract-plugin
module.exports = {"card":"CourtCard_card__QGNgV","editButton":"CourtCard_editButton__3FaPR"};